import React, { Component } from "react";
import { bool, func, shape, string } from "prop-types";
import { connect } from "react-redux";
import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";
import { selectors as sessionSelectors } from "reducers/session";
// import { CORPORATE_GROUP_ENVIRONMENT_TYPE } from "constants.js";

import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import Image from "pages/_components/Image";
import GridTable from "pages/_components/GridTable/GridTable";

import TransactionStatus from "pages/transactions/_components/TransactionStatus";
import * as i18n from "util/i18n";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { EcheqActions } from "pages/echeck/constants";

class TransactionsItem extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        // isDeletingDraft: bool.isRequired,
        transaction: shape({
            cancelEnabled: string.isRequired,
            transaction: shape({
                idTransaction: string,
                creationDateTime: string,
                submitDateTime: string,
                activityName: string,
                idTransactionStatus: string,
            }),
            transactionAmounts: shape(),
        }).isRequired,
        showEnvironment: bool,
        handleOpenCancelForm: func,
        isPendingTransactionPage: bool,
        // activeEnvironment: shape({ type: string.isRequired }).isRequired,
    };

    static defaultProps = {
        showEnvironment: false,
        handleOpenCancelForm: null,
        isPendingTransactionPage: false,
    };

    handleDeleteTransactionDraft = (event, idTransaction) => {
        event.stopPropagation();
        event.preventDefault();
        const { dispatch } = this.props;
        dispatch(transactionsActions.deleteDraftRequest(idTransaction));
    };

    render() {
        const {
            isDesktop,
            transaction: propsTransaction,
            showEnvironment,
            isPendingTransactionPage,
            handleOpenCancelForm,
        } = this.props;
        const { transaction, transactionAmounts } = propsTransaction;
        const {
            creationDateTime,
            submitDateTime,
            activityName,
            idTransactionStatus,
            environmentName,
            environmentType,
            idActivity,
        } = transaction;
        let [currency] = Object.keys(transactionAmounts);
        let amount = transactionAmounts[currency];
        // const isEconomicGroup = activeEnvironment.type === CORPORATE_GROUP_ENVIRONMENT_TYPE;

        let activityTitle = activityName;

        if (activityName === i18n.get("activities.debin.create.send")) {
            amount = transaction?.data?.amountField?.amount;
            currency = transaction?.data?.amountField?.currency;
        }
        if (transaction.data.routeParam === "afip") {
            activityTitle = i18n.get("payments.service.afip");
        }

        if (idActivity === "actions.echeqs.send") {
            activityTitle = i18n.get(`activities.echeq.${transaction?.data?.action?.toLowerCase()}.action`);
            if (transaction?.data?.action === EcheqActions.ADMIT ||
                transaction?.data?.action === EcheqActions.REPUDIATE) {
                const echeq = transaction?.data?.echeqList[0];
                if (echeq.total_endosos > 0) {
                    activityTitle = i18n.get(
                        `activities.echeq.${transaction.data.action.toLowerCase()}.endorse.action`,
                    );
                }
            } 
        }

        if (idActivity === "actions.echeqs.multiple.send") {
            activityTitle = i18n.get(`activities.echeq.${transaction?.data?.action?.toLowerCase()}.action`);
        }

        if (!amount || !currency) {
            amount = transaction?.data?.amount?.quantity;
            currency = transaction?.data?.amount?.currency;
        }

        const showAmount = !!amount && !!currency;

        const menuOptions = [
            {
                text: "menu.cancel.transaction",
                textType: "I18N",
                func: () => {
                    if (handleOpenCancelForm) {
                        handleOpenCancelForm();
                    }
                },
            },
        ];

        const content = (
            <>
                <GridTable.Data className="status" alignX={isDesktop ? "center" : "left"}>
                    <TransactionStatus
                        showIcon
                        idTransactionStatus={idTransactionStatus}
                        showLabel
                        iconFidelity="list"
                    />
                </GridTable.Data>
                <GridTable.Data className="activity" alignX={isDesktop ? "center" : "right"}>
                    {activityTitle.includes(" ") ? activityTitle : i18n.get(activityTitle)}
                </GridTable.Data>
                {showEnvironment && (
                    <GridTable.Data className="environment" alignX={isDesktop ? "center" : "left"}>
                        {!isDesktop && <Image src={`images/${environmentType}.svg`} className="svg-icon" />}
                        {environmentName}
                    </GridTable.Data>
                )}
                <GridTable.Data className="creation-date" alignX={isDesktop ? "center" : "left"}>
                    <CustomData
                        titleText="Creada"
                        dataClass={isDesktop ? "items-center" : "items-start"}
                        valueText={<FormattedDate date={creationDateTime} />}
                    />
                </GridTable.Data>
                <GridTable.Data className="submited-date" alignX={isDesktop ? "center" : "right"}>
                    <CustomData
                        titleText="Enviada"
                        dataClass="items-center"
                        valueText={<FormattedDate date={submitDateTime} />}
                    />
                </GridTable.Data>
                <GridTable.Data className="amount" alignX={isDesktop ? "center" : "left"}>
                    {showAmount && (
                        <CustomData
                            titleText="Monto"
                            dataClass="items-center"
                            valueText={<FormattedAmount currency={currency} quantity={amount} />}
                        />
                    )}
                </GridTable.Data>
                {isPendingTransactionPage && (
                    <GridTable.Data columnStart={isDesktop ? 6 : 3} rowStart={1} rowWidth={1} alignX="end">
                        <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={menuOptions} />
                    </GridTable.Data>
                )}
                {/* <GridTable.Data className="menu" alignY="center">
                    {!isDesktop && idTransactionStatus === "DRAFT" && (
                        <Button
                            type="button"
                            className="btn-only-icon"
                            block={false}
                            loading={isDeletingDraft}
                            onClick={(e) => this.handleDeleteTransactionDraft(e, idTransaction)}
                            bsStyle="circle">
                            <I18n
                                id="transactions.list.history.trashIcon.a11y"
                                componentProps={{ className: "visually-hidden" }}
                            />
                            <Image src="images/trash.svg" className="svg-icon" />
                        </Button>
                    )}
                     {!isEconomicGroup && <ChevromRight />}
                </GridTable.Data> */}
            </>
        );

        return content;
    }
}

const mapStateToProps = (state) => ({
    isDeletingDraft: transactionsSelectors.isDeletingDraft(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(TransactionsItem);
